import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface ISuccess {
  isTechnicalProblem: boolean;
}

export const Success = ({ isTechnicalProblem }: ISuccess) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={[
        {
          gap: '12px',
          width: isDesktop ? 'fit-content' : undefined,
          minWidth: isDesktop ? '440px' : undefined,
          justifyContent: 'center',
          textAlign: isDesktop ? undefined : 'center',
        },
        isDesktop
          ? {
              gap: '12px',
              justifyContent: 'center',
              width: 'fit-content',
              minWidth: '440px',
              alignItems: 'center',
            }
          : {
              gap: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              mb: '40px',
            },
      ]}
    >
      <Typography variant='h3'>{dictionary.thankYou}</Typography>
      <Typography
        variant='body3'
        sx={{
          maxWidth: !isDesktop && !isTechnicalProblem ? '20ch' : undefined,
        }}
      >
        {isTechnicalProblem
          ? dictionary.technicalProblemMessage
          : dictionary.thankYouMessage}
      </Typography>
    </Stack>
  );
};
